import actions from "./actions";

const personioModule = {
  actions,
};

export default personioModule;
